var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: "Test thông báo giới hạn học sinh",
        width: "680px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _vm.schoolRow
        ? _c("div", { staticClass: "ps-school-context" }, [
            _c("div", { staticClass: "ps-school-avatar" }, [
              _c("i", { staticClass: "el-icon-school" }),
            ]),
            _c("div", [
              _c("strong", [_vm._v(_vm._s(_vm.schoolRow.school.name))]),
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.schoolRow.school.id) +
                    " ·\n        " +
                    _vm._s(
                      _vm._f("formatNumber")(_vm.schoolRow.currentStudents)
                    ) +
                    " học sinh đang học ·\n        " +
                    _vm._s(
                      _vm.schoolRow.package
                        ? _vm.schoolRow.package.code
                        : "Chưa gán gói"
                    ) +
                    "\n      "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.schoolRow && _vm.schoolRow.assignment
        ? _c("div", { staticClass: "ps-alert-test-overview" }, [
            _c("div", { staticClass: "ps-alert-test-overview__item" }, [
              _c("span", [_vm._v("Giới hạn hiệu lực")]),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.schoolRow.effectiveLimit)) +
                    " HS"
                ),
              ]),
            ]),
            _c("div", { staticClass: "ps-alert-test-overview__item" }, [
              _c("span", [_vm._v("Đang sử dụng")]),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.formatPercent(_vm.schoolRow.usagePercent)) + "%"
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "ps-alert-test-overview__item" },
              [
                _c("span", [_vm._v("Trạng thái hiện tại")]),
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.schoolRow.locked
                        ? _vm.schoolRow.allowExceedStudentLimit
                          ? "warning"
                          : "danger"
                        : "success",
                      size: "mini",
                      effect: "light",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.schoolRow.locked
                            ? _vm.schoolRow.allowExceedStudentLimit
                              ? "Đã đạt/vượt giới hạn · vẫn cho phép thêm"
                              : "Đã đầy · chặn thêm"
                            : "Còn số lượng"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      !_vm.schoolRow || !_vm.schoolRow.assignment
        ? _c("el-alert", {
            attrs: {
              type: "warning",
              closable: false,
              "show-icon": "",
              title:
                "Trường chưa có gói đang áp dụng nên không thể test cảnh báo.",
            },
          })
        : _c("el-alert", {
            staticClass: "ps-dialog-alert",
            attrs: {
              type: "info",
              closable: false,
              "show-icon": "",
              title:
                "API sẽ tính lại số học sinh, kiểm tra ngưỡng cảnh báo và gửi thử qua Firebase tới các tài khoản trường đã bật nhận thông báo. Quyền vượt giới hạn không thay đổi số liệu hoặc cảnh báo.",
            },
          }),
      _vm.result
        ? _c(
            "div",
            { staticClass: "ps-alert-test-result" },
            [
              _c("el-alert", {
                attrs: {
                  type: _vm.result.sent
                    ? "success"
                    : _vm.result.shouldAlert
                    ? "warning"
                    : "info",
                  closable: false,
                  "show-icon": "",
                  title: _vm.result.message || "Đã nhận kết quả test từ API",
                },
              }),
              _c("div", { staticClass: "ps-alert-test-metrics" }, [
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Tỷ lệ sử dụng")]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.formatPercent(_vm.result.usageRatio * 100)) +
                        "%"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Ngưỡng cấu hình")]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.formatPercent(_vm.result.thresholdRatio * 100)
                      ) + "%"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Ngưỡng số lượng còn lại")]),
                  _c("strong", [
                    _vm._v(
                      "≤ " +
                        _vm._s(
                          _vm._f("formatNumber")(
                            _vm.result.remainingSlotsConfig
                          )
                        )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Trạng thái theo trường")]),
                  _c(
                    "strong",
                    {
                      class: _vm.result.notifyEnabled
                        ? "is-success"
                        : "is-danger",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.result.notifyEnabled ? "Đang bật" : "Đang tắt"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Số chỗ còn lại")]),
                  _c(
                    "strong",
                    { class: { "is-danger": _vm.result.overLimit } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("formatNumber")(_vm.result.remaining)) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Tài khoản nhận")]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.result.deliveredReceiverCount || 0) +
                        "/" +
                        _vm._s(_vm.result.receiverCount || 0)
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Token thành công")]),
                  _c("strong", { staticClass: "is-success" }, [
                    _vm._v(_vm._s(_vm.result.successfulTokenCount || 0)),
                  ]),
                ]),
                _c("div", { staticClass: "ps-alert-test-metric" }, [
                  _c("span", [_vm._v("Token thất bại")]),
                  _c(
                    "strong",
                    { class: { "is-danger": _vm.result.failedTokenCount > 0 } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.result.failedTokenCount || 0) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm.result.title || _vm.result.body
                ? _c("div", { staticClass: "ps-alert-test-preview" }, [
                    _c(
                      "span",
                      { staticClass: "ps-alert-test-preview__label" },
                      [_vm._v("Nội dung thông báo")]
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.result.title))]),
                    _c("p", [_vm._v(_vm._s(_vm.result.body))]),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Đóng")]
          ),
          _vm.schoolRow && _vm.schoolRow.assignment
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("send", _vm.schoolRow.school.id)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-bell" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.result ? "Gửi lại test" : "Gửi test Firebase"
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }